import { apiGet, apiPost, apiPatch, apiDelete } from '../api-client.ts';
import type { ModalitaRaccolta } from '@/types/entities/raccolta-delega.ts';

interface ArchivioRecord {
  id: number;
  codFiscale: string;
  codCe: string | null;
  codEc: string | null;
  cognNome: string | null;
  operatore: string | null;
  operatoreNome: string | null;
  origine: string;
  cognome: string | null;
  nome: string | null;
  datapres: string | null;
  dataNascita: string | null;
  coloreId: number | null;
  coloreNome: string | null;
  coloreCss: string | null;
  modalitaRaccolta: ModalitaRaccolta | null;
  note: string | null;
  createdAt: string | null;
}

export interface ModificaArchivio {
  operatore: string | null;
  modalitaRaccolta: ModalitaRaccolta | null;
  datapres: string | null;
  note: string | null;
}

interface ListaResult {
  archivio: ArchivioRecord[];
  count: number;
  page: number;
  totalPages: number;
  pageSize: number;
}

export const archivioApi = {
  lista: (params: Record<string, string | number | undefined> = {}) => {
    const qs = Object.entries(params)
      .filter(([, v]) => v != null && v !== '')
      .map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`)
      .join('&');
    return apiGet<ListaResult>(`archivio/lista${qs ? `?${qs}` : ''}`);
  },

  crea: (data: { codiceFiscale: string; operatore?: string; note?: string; coloreId: number; modalitaRaccolta: ModalitaRaccolta }) =>
    apiPost<ArchivioRecord>('archivio', data),

  aggiorna: (id: number, dati: ModificaArchivio) =>
    apiPatch<ArchivioRecord>(`archivio/${id}`, dati),

  cambiaColore: (id: number, coloreId: number) =>
    apiPatch<ArchivioRecord>(`archivio/${id}/colore`, { coloreId }),

  elimina: (id: number) =>
    apiDelete<{ ok: boolean }>(`archivio/${id}`),
};
